import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function DistribucionAnexo21y22RMF2026Certificado() {
  return (
    <CategoryPage
      category="distribucionAnexo21Y22Rmf2026Certificado2026"
      pageTitle="Certificado JSON 2026"
    />
  );
}

export default DistribucionAnexo21y22RMF2026Certificado;
